"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    "svg",
    { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" },
    _react2.default.createElement(
      "circle",
      {
        cx: "50",
        cy: "50",
        r: "29.6",
        fill: "none",
        stroke: "#080808",
        strokeWidth: "7" },
      _react2.default.createElement("animate", {
        attributeName: "r",
        begin: "-0.5s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0 0.2 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "0;40"
      }),
      _react2.default.createElement("animate", {
        attributeName: "opacity",
        begin: "-0.5s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0.2 0 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "1;0"
      })
    ),
    _react2.default.createElement(
      "circle",
      {
        cx: "50",
        cy: "50",
        r: "8.3",
        fill: "none",
        stroke: "#080808",
        strokeWidth: "7" },
      _react2.default.createElement("animate", {
        attributeName: "r",
        begin: "0s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0 0.2 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "0;40"
      }),
      _react2.default.createElement("animate", {
        attributeName: "opacity",
        begin: "0s",
        calcMode: "spline",
        dur: "1",
        keySplines: "0.2 0 0.8 1",
        keyTimes: "0;1",
        repeatCount: "indefinite",
        values: "1;0"
      })
    )
  );
};